var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"detail"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"row"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"action"})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }